// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-simple-suggest/dist/styles.css
// module id = 472
// module chunks = 1